<app-product-table [isArchive]="true"

></app-product-table>

